import React, {Component } from 'react';
import { Breadcrumb, Card,Divider,Button,DatePicker,Spin,Empty,Modal } from 'antd';
import { DashboardOutlined, FilePdfOutlined,SendOutlined,FileSearchOutlined, DoubleRightOutlined} from '@ant-design/icons';
import {Row, Col} from 'react-bootstrap';
import moment from 'moment';
import mHelper from './../../config/Helper';
import mDownloadControllers from './../../control/download/index.controllers';
import HeaderTitle from '../../component/HeaderTitle/HeaderTitle';
var isLogin = JSON.parse(mHelper.GET_COOKIES('login_portal'));

const { Meta } = Card;
var thisComponent;
class DocumentA extends Component {

    
    constructor(props) {
        super(props);
        this.state = {
            AdCode : isLogin.company.ad_code,
            AdName : isLogin.company.ad_name,
            Periode: mHelper.GET_DATE_DIGIPOS(),
            loadingDocumentA : false,
            dataDocBukpot : [],
            dataDocBar:[],
            dataSummary : []
        };
        thisComponent = this;
    }

    
    async componentDidMount() {
        this.onGetBarRecon();
    }

    onChangeDate = (date, dateString) => {
        this.setState({Periode:dateString});
    }

    onGetBarRecon = () => {
        this.setState({loadingDocumentA : true});
        mDownloadControllers.GET_DOCUMENT_A(this.state.Periode,(r)=>{
            this.setState({loadingDocumentA : false,dataDocBar : r.dataBar,dataDocBukpot : r.dataBukpot, dataSummary : r.dataSummary});
        });
    }

    onProcessDocumentA = () =>{
        this.onGetBarRecon();
    }

    onViewDocBar = (name) =>{
        mDownloadControllers.VIEW_DOC_BAR(name,(r)=>{
            // console.log(r);
            if(r.success == true){
                const buff = Buffer.from(r.data, "base64");
                const file = new Blob([buff],{type: 'application/pdf'});
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }else{
                Modal.info({
                    title: 'Error',
                    content: (
                      <div>
                        <p>File tidak bisa ditemukan !</p>
                      </div>
                    ),
                    onOk() {},
                });
            }
        });
    }

    onViewDocBukpot = (name) =>{
        mDownloadControllers.VIEW_DOC_BUKPOT(name,(r)=>{
            // console.log(r);
            if(r.success == true){
                const buff = Buffer.from(r.data, "base64");
                const file = new Blob([buff],{type: 'application/pdf'});
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }else{
                Modal.info({
                    title: 'Error',
                    content: (
                      <Row>
                        <p>File tidak bisa ditemukan !</p>
                      </Row>
                    ),
                    onOk() {},
                });
            }
        });
    }
    
    render(){
        return (
            <div>
                <Breadcrumb>
                    <Breadcrumb.Item>
                    <div className="TitlePage">
                        <DashboardOutlined className="icon" /><DoubleRightOutlined className="iconArrow" /> <h3>Document AD A</h3>
                    </div>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Row>
                <HeaderTitle onChangeDate={this.onChangeDate} onProcess={this.onProcessDocumentA} momen={moment(this.state.Periode, 'YYYY-MM')}/>
                    <Col sm={12}  lg={12} style={{marginBottom:20}}>
                        <Spin spinning={this.state.loadingDocumentA} >
                            <Card bordered={false} className="box" style={{textAlign:"left"}}>
                                <Divider orientation="left">DOCUMENT BAR RECON PERIODE {this.state.Periode}</Divider>
                                {this.state.dataDocBar.length === 0 ? <Empty /> : (
                                    <Row>
                                        {this.state.dataDocBar.map((bar,index) => (
                                            <Col sm={4} key={index}  lg={4} style={{marginBottom:10}}>
                                                <Card 
                                                    actions={[
                                                        <Button type="text" key="view-bar" onClick={event => {this.onViewDocBar(bar.name)} }><FileSearchOutlined/> VIEW DOCUMENT</Button>
                                                    ]}
                                                >
                                                    <Meta
                                                        avatar={
                                                            <FilePdfOutlined style={{color : '#29647B'}}/>
                                                        }
                                                        title="BAR A Recon"
                                                        description={"Nomor : "+bar.no_bar}
                                                    />
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                )}
                            </Card>
                        </Spin>
                    </Col>
                    <Col sm={12}  lg={12} style={{marginBottom:20}}>
                        <Spin spinning={this.state.loadingDocumentA} >
                            <Card bordered={false} className="box" style={{textAlign:"left"}}>
                                <Divider orientation="left">DOCUMENT SUMMARY PERIODE {this.state.Periode}</Divider>
                                {this.state.dataSummary.length === 0 ? <Empty /> : (
                                    <Row>
                                        {this.state.dataSummary.map((bar,index) => (
                                            <Col sm={4} key={index} lg={4} style={{marginBottom:10}}>
                                                <Card 
                                                    actions={[
                                                        <Button type="text" key="view-bar" onClick={event => {this.onViewDocBar(bar.name)} }><FileSearchOutlined/> VIEW DOCUMENT</Button>
                                                    ]}
                                                >
                                                    <Meta
                                                        avatar={
                                                            <FilePdfOutlined style={{color : '#29647B'}}/>
                                                        }
                                                        title={bar.no_bar}
                                                        description={"Nomor : "+bar.no_bar}
                                                    />
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                )}
                            </Card>
                        </Spin>
                    </Col>
                    <Col sm={12}  lg={12} style={{marginBottom:20}}>
                        <Spin spinning={this.state.loadingDocumentA} >
                            <Card bordered={false} className="box" style={{textAlign:"left"}}>
                                <Divider orientation="left">DOCUMENT BUKTI POTONG PERIODE {this.state.Periode}</Divider>
                                {this.state.dataDocBukpot.length === 0 ? <Empty /> : (
                                    <Row>
                                        {this.state.dataDocBukpot.map((bukpot,index) => (
                                            <Col sm={4} key={index} lg={4} style={{marginBottom:10}}>
                                                <Card 
                                                actions={[
                                                    <Button type="text" key="view-bar" onClick={event => {this.onViewDocBukpot(bukpot.name)} }><FileSearchOutlined/> VIEW DOCUMENT</Button>
                                                ]}
                                                >
                                                    <Meta
                                                        avatar={
                                                            <FilePdfOutlined style={{color : '#29647B'}}/>
                                                        }
                                                        title="BUKTI POTONG "
                                                        description={"NPWP : "+bukpot.npwp}
                                                    />
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                )}
                            </Card>
                        </Spin>
                    </Col>

                </Row>
            </div>
        )
    }
}


export default DocumentA;